import { CircularProgress, createTheme, IconButton, withStyles } from '@material-ui/core';
import { MuiThemeProvider } from '@material-ui/core/styles';
import RefreshIcon from '@material-ui/icons/Autorenew';
import BarChartIcon from '@material-ui/icons/InsertChart';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { connect } from 'react-redux';
import * as SettingsActions from '../../../redux/actions/setting.actions';
import { BLUE } from '../../../_config/consts';
import { getColorFromThemeName } from '../../../_config/utils';

const styles = theme => ({
  titleText: {
    margin: 0,
    fontWeight: 'bold',
    color: '#3f3f3f',
    marginTop: 5,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '99.9%',
    borderRadius: 10,
    padding: 20,
    paddingTop: 12,
    justifyContent: 'center',
    position: 'relative',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  icon: {
    fontSize: 40,
    color: '#3f3f3f',
  },
  countText: {
    color: '#3f3f3f',
    margin: 0,
    fontSize: 35,
  },
  progress: {
    margin: 0,
    marginTop: 0,
    padding: 0,
    left: '50%',
    position: 'absolute',
    height: '38px !important',
    width: '38px !important',
    zIndex: 10000,
  },
  refreshHeader: {
    display: 'flex',
    alignItems: 'center',
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  refreshIcon: {
    fontSize: 25,
    color: '#3f3f3f',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px #f1f1f1 solid',
    marginTop: 10,
    paddingBottom: 10,
  },
  rowBodyContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  rowTitle: {
    fontWeight: 'bold',
    color: '#3f3f3f',
    margin: 5,
    marginLeft: 0,
  },
  listBodyContainer: {
    maxHeight: 400,
    overflow: 'scroll',
  },
});

const theme = createTheme({
  palette: {
    primary: { 500: BLUE },
  },
});

const CompanyNotificationHistoryRow = ({ event, classes }) => {
  return (
    <div className={classes.row}>
      <div className={classes.rowBodyContainer}>
        <h4 className={classes.rowTitle}><Entity entity="hardwareStatusReportSent" /></h4>
        <h5 className={classes.tableBodyText} style={{ fontSize: 16, marginTop: 10, color: '#3f3f3f' }}>
          <Entity entity="hardwareStatusReportSentDescription" />
        </h5>
      </div>
      <h5 className={classes.tableBodyText} style={{ color: '#3f3f3f' }}>{moment(event.timestamp).format('LLL')}</h5>
    </div>
  );
}

const EmptyHistoryView = () => (
  <div style={{ height: 100, flexDirection: 'column', margin: 20, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <BarChartIcon style={{ color: '#bdbdbd', fontSize: 50 }} />
    <h3 style={{ color: '#bdbdbd', fontWeight: 'bold', marginTop: 0 }}><Entity entity="noHistoryFound" /></h3>
  </div>
);

@connect(state => ({ 
  companyNotificationsHistory: state.settings.items.companyNotifications.history,
  viewLoading: state.utils.viewLoading, 
  themeName: state.settings.items.theme.data.themeName 
}))
class CompanyNotificationsHistorySection extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isRefreshing: false,
    };
  }

  componentDidMount() {
    this.onRefreshData();
  }

  onRefreshData() {
    const { dispatch } = this.props;
    this.setState({ isRefreshing: true });
    dispatch(SettingsActions.fetchCompanyNotificationsHistory()).finally(() => {
      this.setState({ isRefreshing: false });
    });
  }

  onLoadMoreEvents(page) {
    const { dispatch } = this.props;
    dispatch(SettingsActions.fetchCompanyNotificationsHistory(page, true));
  }

  render() {
    const { companyNotificationsHistory: { content: historyData, pagination: { number, totalPages }}, classes, themeName } = this.props;
    const { isRefreshing } = this.state;
    const textColor = getColorFromThemeName(themeName);
    
    return (
      <MuiThemeProvider theme={theme}>
        <div className={classes.container} style={{ opacity: isRefreshing ? 0.5 : 1, marginRight: 20 }}>
          <div className={classes.header}>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
              <h2 style={{ color: '#3f3f3f', marginBottom: 0, marginTop:0, fontWeight: 'bold', fontSize: 25 }}><Entity entity="hardwareStatusReportHistory" /></h2>
            </div>
            <div className={classes.refreshHeader}>
              <IconButton
                disabled={isRefreshing}
                style={{ opacity: isRefreshing ? 0.5 : 1 }}
                onClick={() => this.onRefreshData()}
              >
                <RefreshIcon className={classes.refreshIcon} style={{ color: textColor || BLUE }} />
              </IconButton>
            </div>
          </div>
          {isRefreshing ? <CircularProgress color="primary" className={classes.progress} /> : null}
          <div style={{ overflowY: 'auto', height: '120vh', paddingLeft: 15, paddingBottom: 220, marginTop: 10 }}>
            <InfiniteScroll
              initialLoad={false}
              loadMore={() => this.onLoadMoreEvents(number + 1)}
              hasMore={number + 1 < totalPages}
              useWindow={false}
              loader={
                <div style={{ marginTop: 20, backgroundColor: 'white', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                  <h4 style={{ textAlign: 'center', color: '#3f3f3f' }}><Entity entity="loadingHistory" /></h4>
                  <CircularProgress className={classes.circularProgress} />
                </div>
              }
            >
              <div>
                {!_.isEmpty(historyData) ?
                  _.map(historyData, (log, key) =>
                    <CompanyNotificationHistoryRow
                      key={log.id}
                      event={log}
                      classes={classes}
                    />)
                    : (
                      <div>
                        <EmptyHistoryView />
                      </div>
                    )
                  }
              </div>
            </InfiniteScroll>
          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}

export default withStyles(styles)(CompanyNotificationsHistorySection); 